export enum ContactTypeEnum {
    NORMAL = 'NORMAL',
    GROUP = 'GROUP'
}